<template>
  <div class="">
    <Nav @set-status="setStatus" />
    <b-container>
      <b-tabs content-class="mt-3" v-model="activeTab" @input="handleTabChange">
        <b-tab title="By export" active>
          <b-table
            show-empty
            bordered
            small
            stacked="md"
            head-variant="light"
            :items="reImport.data"
            :fields="tableFields"
            :busy="reImport.status === 'fetching'"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" variant="yellow" />
              </div>
            </template>

            <template v-slot:cell(actions)="row">
              <div class="text-center">
                <b-icon
                  v-if="row.field.details"
                  v-b-tooltip.hover
                  title="Details"
                  icon="eye"
                  class="h5 m-2 cursor-pointer"
                  @click="row.toggleDetails"
                />

                <b-icon
                  icon="check-square"
                  v-if="row.item.status == 1"
                  v-b-tooltip.hover
                  title="Complete re-import"
                  class="h5 m-2 cursor-pointer"
                  @click="completeReImport(row.item)"
                ></b-icon>
                <b-icon
                  icon="trash"
                  v-if="row.item.status == 1"
                  v-b-tooltip.hover
                  title="Delete"
                  class="h5 m-2 cursor-pointer"
                  @click="deleteReImport(row.item)"
                ></b-icon>
              </div>
            </template>

            <template #row-details="{ item }">
              <b-card>
                <b-row>
                  <b-col sm="12" md="12" lg="12">
                    <VehiclesTable
                      class="mt-2 px-3"
                      :vehicles="item.vehicles"
                      :isSelectMode="false"
                    />
                  </b-col>
                  <!--               <b-col sm="12" md="6" lg="6">
                <AddonsBreakdown class="mt-2" :expensesInformation="item" />
              </b-col> -->
                </b-row>
              </b-card>
            </template>
          </b-table>
          <b-pagination
            v-if="reImport.status != 'fetching'"
            :value="reImport.data.currentPage"
            :total-rows="reImport.data.total"
            :per-page="reImport.data.perPage"
            class="mb-2"
            align="end"
            @change="changePage($event)"
          />
        </b-tab>
        <b-tab title="By vin">
          <ReImportTableByVin
            ref="reImportTableByVin"
            :status="status.toString()"
          />
        </b-tab>
      </b-tabs>
    </b-container>

    <b-modal
      id="reImportDetailsModal"
      ref="reImportDetailsModal"
      size="lg"
      hide-footer
      body-class="pl-0 pr-0"
      ok-disabled
      scrollable
      @hide="hideModal"
    >
      <ReImportForm
        :reImportItem="reImportItem"
        :refreshData="getData"
        :hideModal="hideModal"
      />
    </b-modal>
  </div>
</template>
<script>
import {
  GET_REIMPORT_DATA,
  PUT_COMPLETE_REIMPORT,
  DELETE_REIMPORT,
} from "./actions";
import Nav from "./Nav.vue";
import { mapState } from "vuex";
import { generalMixin } from "@/modules/mixin.js";
import { superAdminMixin } from "../mixins";
import ReImportForm from "./ReImportForm.vue";
import VehiclesTable from "./VehiclesTable.vue";
import ReImportTableByVin from "./ReImportTableByVin.vue";
export default {
  name: "ReImportTable",
  components: {
    Nav,
    ReImportForm,
    VehiclesTable,
    ReImportTableByVin,
  },
  mixins: [generalMixin, superAdminMixin],

  computed: {
    ...mapState({
      reImport: (state) => state.superAdminStore.reImport.reImportData,
    }),

    tableFields() {
      let fields = [
        {
          key: "createdAt",
          label: "Created at",
          class: "text-center",
          formatter: (date) => this.$options.filters.formatDate(date),
        },
        {
          key: "exportLoad.referenceNumber",
          label: "Reference number",
          class: "text-center",
        },
        {
          key: "description",
          label: "Description",
          class: "text-center",
        },
        {
          key: "actions",
          label: "Actions",
          note: false,
          details: true,
          validation: false,
          delete: true,
        },
      ];

      // Solo agregar el campo updatedAt cuando status sea 2
      if (this.status === 2) {
        // Insertar el campo updatedAt antes de actions
        fields.splice(3, 0, {
          key: "updatedAt",
          label: "Landed date",
          class: "text-center",
          formatter: (date) => this.$options.filters.formatDate(date),
        });
      }

      return fields;
    },
  },
  data() {
    return {
      options: {
        assign: false,
        rolFilter: false,
        add: false,
        fun: this.getData,
      },
      status: 1,
      reImportItem: {},
      activeTab: 0, // Índice de la pestaña activa (0: By export, 1: By vin)
    };
  },
  mounted() {
    this.$store.commit(
      "setAddFunction",
      this.userHasPermission("exportLoads", "write") ? this.showModal : null
    );
    this.getData();
  },
  methods: {
    getData(filter = "") {
      this.$store.dispatch(GET_REIMPORT_DATA, {
        status: this.status,
        search: filter,
      });
    },
    setStatus(status) {
      this.status = status;
      this.getData();
    },
    showModal() {
      this.reImportItem = {};

      this.$bvModal.show("reImportDetailsModal");
    },
    hideModal() {
      this.$bvModal.hide("reImportDetailsModal");
    },
    completeReImport(item) {
      this.$store
        .dispatch(PUT_COMPLETE_REIMPORT, { id: item.id })
        .then(() => {
          this.makeToast(
            "Success",
            "Re-import completed successfully",
            "success"
          );
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Internal server error, try again later", {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    async deleteReImport(item) {
      const confirm = await this.showConfirmDeleteBox();
      if (!confirm) return;
      this.$store
        .dispatch(DELETE_REIMPORT, { id: item.id })
        .then(() => {
          this.makeToast(
            "Success",
            "Re-import deleted successfully",
            "success"
          );
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Internal server error, try again later", {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    handleTabChange(tabIndex) {
      // Cuando se cambia a la pestaña "By vin" (índice 1)
      if (tabIndex === 1 && this.$refs.reImportTableByVin) {
        this.$refs.reImportTableByVin.getData();
      }
      // Cuando se cambia a la pestaña "By export" (índice 0)
      else if (tabIndex === 0) {
        this.getData();
      }
    },
    changePage(page) {
      this.$store
        .dispatch(GET_REIMPORT_DATA, {
          status: this.status,
          search: "",
          page: page,
        })
        .then(() => {
          console.log("Page changed successfully");
        })
        .catch((error) => {
          console.error("Error changing page:", error);
        });
    },
  },
};
</script>
